var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChapterCircleOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 519,
    height: 455,
    viewBox: "0 0 519 455",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    className: "outer-circle-one",
    d: "M483.135 262.746C466.141 370.892 372.561 453.601 259.621 453.601C146.681 453.601 53.0699 370.892 36.0762 262.746L78.5223 220.3L38.2748 180.053C59.9865 77.7543 150.818 1 259.606 1C368.393 1 459.209 77.7543 480.921 180.068L440.674 220.315L483.12 262.762L483.135 262.746Z",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "inner-circle-one",
    d: "M230.336 2.37109V37.351C143.673 50.5887 76.0491 121.724 68.2012 210.006",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "inner-circle-one",
    d: "M230.337 451.877V417.264C139.383 403.354 69.4078 325.714 67.4688 231.355",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "inner-circle-one",
    d: "M288.877 2.37109V37.351C375.525 50.5887 443.134 121.724 450.997 210.006",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "inner-circle-one",
    d: "M288.877 451.877V417.264C379.8 403.354 449.775 325.714 451.73 231.355",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "square",
    d: "M51.3755 220.395L26.1875 195.207L0.999513 220.395L26.1875 245.583L51.3755 220.395Z",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "square",
    d: "M493.048 245.575L518.236 220.387L493.048 195.199L467.86 220.387L493.048 245.575Z",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "short-line",
    d: "M69.7882 257.539L40.7324 286.61",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "short-line",
    d: "M449.422 257.539L478.493 286.61",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "short-line",
    d: "M72.8585 184.477L43.8027 155.406",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "short-line",
    d: "M446.34 184.477L475.411 155.406",
    stroke: "#DED8FF",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChapterCircleOne);
export default __webpack_public_path__ + "static/media/chapter-circle-one.33ecd7cabe57f093d40723a9bad1b019.svg";
export { ForwardRef as ReactComponent };